import {
  BranchData,
  ClientDataType,
  SubBranchData,
} from '../../context/clients/ClientsContextProvider';
import {
  BranchLocationStatus,
  ClientLocationStatus,
  IChecklist,
} from './checklist.d';

export type ChecklistSelectedLocation =
  | ClientDataType
  | BranchData
  | SubBranchData
  | null;

export function getChecklistLocationStatus(
  checklist: IChecklist,
  selectedLocation: ChecklistSelectedLocation,
): ClientLocationStatus | BranchLocationStatus | null {
  if (!selectedLocation) return null;

  if (selectedLocation.isClient) {
    return (
      checklist.clientIds?.find(c => c._id === selectedLocation.id)?.status ??
      null
    );
  }

  if (selectedLocation.isSubBranch) {
    return (
      checklist.subBranchIds?.find(sb => sb._id === selectedLocation.id)
        ?.status ?? null
    );
  }

  return (
    checklist.branchIds?.find(b => b._id === selectedLocation.id)?.status ??
    null
  );
}

export function getChecklistLocationType(
  selectedLocation: ChecklistSelectedLocation,
): 'client' | 'branch' | 'subBranch' | undefined {
  if (!selectedLocation) return undefined;
  if (selectedLocation.isClient) return 'client';
  if (selectedLocation.isSubBranch) return 'subBranch';
  return 'branch';
}
